<template>
  <div id="counter">
    <span id="timer">{{ time }}</span>
  </div>
</template>

<script>

export default {
  name: 'Counter',
  props: {
    limitTime: Number,
    roundNumber: Number
  },
  data: function(){
    return{
      time: 0,
      round: this.roundNumber
    }
  },
  created: function() {
    this.time = this.limitTime;
    this.startTimer();
  },
  methods:{
    timesUp(){
      this.$emit('timeUp');
      this.$forceUpdate();
    },
    reduceTimer(){
      this.time=this.time-1;
    },
    restartTimer(){
      this.time = this.limitTime;
      if(this.time >= 1 ){
          this.reduceTimer();
      }
      else{
        this.timesUp();
      }
      this.startTimer();
    },
    startTimer(){

      if(this.time >= 1 ){
          this.reduceTimer();
          setTimeout(() => { this.startTimer(); }, 1000);
      }
      else{
        this.timesUp();
      }

    }

  }
}
</script>
